import { assetNameToRgba, ASSET_SYMBOLS_PALETTE } from '@blockanalitica/ui';
//generic can be used for charts where we show the data in a bar chart or a doughnut chart
//and we have several of the same symbols in the chart
export function generateGradientColor(
  baseColor: string,
  index: number,
  total: number
) {
  const match = baseColor.match(
    /^rgba?\((\d+), (\d+), (\d+)(?:, (\d+\.?\d*))?\)$/
  );
  if (!match) {
    return baseColor;
  }
  const r = Number(match[1]);
  const g = Number(match[2]);
  const b = Number(match[3]);
  const a = match[4] ? parseFloat(match[4]) : 1;

  if (index === 0) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }

  const lightnessFactor = 0.3 + (index / total) * 0.8;

  const newR = Math.min(255, Math.round(r * lightnessFactor));
  const newG = Math.min(255, Math.round(g * lightnessFactor));
  const newB = Math.min(255, Math.round(b * lightnessFactor));

  return `rgba(${newR}, ${newG}, ${newB}, ${a})`;
}

// For emode since there are always 2 of them, a master and a apprentice
export function generateGradientColorEmode(baseColor: string) {
  const match = baseColor.match(
    /^rgba?\((\d+), (\d+), (\d+)(?:, (\d+\.?\d*))?\)$/
  );
  if (!match) {
    return baseColor;
  }
  const r = Number(match[1]);
  const g = Number(match[2]);
  const b = Number(match[3]);
  const a = match[4] ? parseFloat(match[4]) : 1;

  const lightnessFactor = 1.5;
  const newR = Math.min(255, Math.round(r * lightnessFactor));
  const newG = Math.min(255, Math.round(g * lightnessFactor));
  const newB = Math.min(255, Math.round(b * lightnessFactor));

  return `rgba(${newR}, ${newG}, ${newB}, ${a})`;
}

export function getTokenColor(token: string) {
  let sanitized = false;
  const ogToken = token;
  const sanitizedToken = token.replace('-emode', '');
  if (sanitizedToken !== ogToken) {
    sanitized = true;
  }
  try {
    const color = assetNameToRgba(sanitizedToken);
    if (sanitized) {
      return generateGradientColorEmode(color || '#808080');
    }
    return color || '#808080';
  } catch {
    return '#808080';
  }
}

export function determineAssetColor(symbol: string) {
  let assetSymbol = symbol;
  if (assetSymbol.startsWith('PT')) {
    const parts = assetSymbol.split('-');
    assetSymbol = parts[1];
  }

  return ASSET_SYMBOLS_PALETTE[assetSymbol] || '#ffffff';
}
